<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>资讯</span></div>
			
			<div class="news-info flex-start">
				<img class="news-info-image" :src="info.image"/>
				
				<div class="news-text">
					<div class="news-name">{{info.title}}</div>
					<div class="news-time">{{info.releaseTime}}</div>
					<div class="news-time" v-html="info.content"></div>
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import {getNewsInfo} from "@/api/index"
export default {
	name: 'index',
	data(){
		return {
			id:0,
			info:{},
		}
	},
	mounted() {
		this.id = this.$route.query.id || "";
		this.getInfo();
	},
	methods:{
		getInfo(){
			getNewsInfo({id:this.id}).then(res=>{
				if(res.code == 1000){
					this.info = res.data
				}else{
					return this.$message.error(res.message);
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
	.news-info{
		width: 1320px;
		min-height: 66vh;
		background: #FFFFFF;
		padding: 20px;
		justify-content: flex-start;
		align-items: flex-start;
		.news-info-image{
			width: 500px;
			height: auto;
			object-fit: contain;
			flex: 0 0 500px;
		}
		.news-text{
			width: 100%;
			margin-left: 30px;
			.news-name{
				font-size: 24px;
				font-weight: 500;
				color: #070B13;
			}
			.news-time{
				opacity: 0.6;
				font-size: 16px;
				color: #070B13;
				margin-top: 20px;
			}
		}
	}
</style>
